export const setDashboardSelectedMissionsApprovals = missionsApprovals => ({
  type: 'SET_DASHBOARD_SELECTED_MISSIONS_APPROVALS',
  payload: missionsApprovals,
});
